import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

L.Icon.Default.imagePath = '/images/leaflet/';
